(function () {
  'use strict';

  function getGrid(root) {
    return (
      root.querySelector('#main-collection-product-grid ol') ||
      root.querySelector('[data-product-list]')
    );
  }

  function getItems(root) {
    const grid = getGrid(root);
    if (!grid) return [];
    const tagged = grid.querySelectorAll('[data-collection-product]');
    if (tagged.length > 0) return tagged;
    return grid.querySelectorAll(':scope > li');
  }

function updateShownCount() {
    const grid = getGrid(document);
    if (!grid) return;
    const count = grid.querySelectorAll(':scope > li').length;
    document.querySelectorAll('[data-shown-count]').forEach((el) => {
      el.textContent = count;
    });
  }

  function initLoadMore() {
    const btn = document.querySelector('[data-load-more-btn]');
    if (!btn) return;
    if (btn.dataset.loadMoreReady) return;
    btn.dataset.loadMoreReady = 'true';
    btn.addEventListener('click', handleLoadMore);
    console.log('[LoadMore] Button initialised');
  }

  async function handleLoadMore(e) {
    const btn = e.currentTarget;
    const rawNextUrl = btn.dataset.nextUrl;
    if (!rawNextUrl) return;

    const grid = getGrid(document);
    if (!grid) return;

    const nextUrl = getNextUrlWithCurrentSort(rawNextUrl);
    setLoading(btn, true);

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = getItems(doc);

      newItems.forEach((item) => {
        item.style.opacity = '0';
        item.style.transition = 'opacity 0.3s ease';
        grid.appendChild(item);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            item.style.opacity = '1';
          });
        });
      });

      updateShownCount();

      const nextBtn = doc.querySelector('[data-load-more-btn]');
      if (nextBtn) {
        btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
        setLoading(btn, false);
      } else {
        // No more pages — remove only the button, keep the counter visible
        const pagination = btn.closest('.pagination');
        if (pagination) {
          pagination.style.transition = 'opacity 0.3s ease';
          pagination.style.opacity = '0';
          setTimeout(() => pagination.remove(), 300);
        } else {
          btn.remove();
        }
      }
    } catch (err) {
      console.error('[LoadMore] Failed to fetch next page:', err);
      setLoading(btn, false);
    }
  }

  function getNextUrlWithCurrentSort(nextUrl) {
    const currentParams = new URLSearchParams(window.location.search);
    const sortBy = currentParams.get('sort_by');
    const url = new URL(nextUrl, window.location.origin);
    if (sortBy) {
      url.searchParams.set('sort_by', sortBy);
    } else {
      url.searchParams.delete('sort_by');
    }
    return url.toString();
  }

  function setLoading(btn, isLoading) {
    const label = btn.querySelector('[data-load-more-label]');
    const spinner = btn.querySelector('[data-load-more-spinner]');
    btn.disabled = isLoading;
    btn.setAttribute('aria-busy', isLoading);
    if (label) label.style.visibility = isLoading ? 'hidden' : 'visible';
    if (spinner) spinner.style.display = isLoading ? 'inline-block' : 'none';
  }

  document.addEventListener('DOMContentLoaded', initLoadMore);

  window.addEventListener('collection:rerendered', () => {
    setTimeout(() => {
      const btn = document.querySelector('[data-load-more-btn]');
      if (btn) delete btn.dataset.loadMoreReady;
      initLoadMore();
    }, 300);
  });

})();